import { Link, Outlet } from "react-router-dom";
import { CaseKeepLogo } from "../components/common/CaseKeepLogo/CaseKeepLogo";

export const PublicLayout: React.FC = () => {
  return (
    <div className="flex flex-col h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <header className="flex-shrink-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center h-16">
            <Link to="/" className="flex items-end">
              <CaseKeepLogo className="dark:fill-white h-8 w-auto mr-2" />
              <span className="text-gray-900 dark:text-white text-lg">
                Case<span className="font-bold">keep</span>
              </span>
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default PublicLayout;
